import { FRONTEND_ENDPOINTS } from "@/public/Constants/endpoints";

export const COLLECTIONS_LINK = [
    {
        link: FRONTEND_ENDPOINTS?.OLD_MONEY_EDIT_LINK,
        text: "Old Money Edit",
        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232935/New%20Website/Header/jxzt7klqx3c8gaahg0fa.webp",
    },
    {
        link: FRONTEND_ENDPOINTS?.SERENA_BY_THE_SEA_PRODUCTS_LINK,
        text: "Serena By The Sea",
        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/f9r2q8fgexzlcwn0vi8q.webp",
    },
    {
        link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
        text: "Serena Collection",
        src: "https://res.cloudinary.com/wearthat/image/upload/v1747232934/New%20Website/Header/rk87eqdv906emhmny5ay.webp",
    },
    {
        link: FRONTEND_ENDPOINTS?.JESSIE_PRODUCTS_LINK,
        text: "Wear That x Jessie",
        src: "https://res.cloudinary.com/wearthat/image/upload/v1747247593/New%20Website/zprsum9eokhbbn5esjmi.webp",
    },
];

export const QUICK_LINKS = [
    {
        link: FRONTEND_ENDPOINTS?.OLD_MONEY_EDIT_LINK,
        text: "Best Sellers",
    },
    {
        link: FRONTEND_ENDPOINTS?.SERENA_BY_THE_SEA_PRODUCTS_LINK,
        text: "Track Order",
    },
    {
        link: FRONTEND_ENDPOINTS?.SERENA_PRODUCTS_LINK,
        text: "Shop Latest",
    },
    {
        link: FRONTEND_ENDPOINTS?.JESSIE_PRODUCTS_LINK,
        text: "Wear That x Basma",
    },
];
